import Role from '@/models/role'
import BaseService from '@/services/BaseService'

export class RoleService extends BaseService<Role> {
  constructor() {
    super('roles/')
  }
  public async getForSchool(schoolID: number): Promise<Role[]> {
    const result = await this.instance.get(this.resourcePath + 'school/', {
      params: {
        schoolID,
      },
    })
    return result.data
  }
}

export default new RoleService()
